import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'app-user-image',
  templateUrl: './user-image.component.html',
  styleUrls: ['./user-image.component.scss']
})
export class UserImageComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() byUserId: boolean;
  @Input() userId: number;


  @Input() firstName: any;
  @Input() lastName: any;
  @Input() subTitlePrefix: any;
  @Input() toolTipSubTitlePrefix: any;
  @Input() subTitle: any;
  @Input() image: any;
  @Input() theme: any;
  @Input() onlyPhoto = false;
  @Input() imageSize = '32';

  colorTitle: string = '#000000';
  colorSubTitle: string = '#909FA7';

  constructor(private _elementRef: ElementRef,
              private userService: UserService,
              public http: HttpClient) {
  }

  ngOnInit() {
    switch (this.theme) {
      case 'white' :
        this.colorTitle = '#ffffff';
        this.colorSubTitle = '#000000';
        return ;
      case 'black' :
        this.colorTitle = '#000000';
        this.colorSubTitle = '#000000';
        return ;
    }
    if (this.byUserId) {
      let members = JSON.parse(localStorage.getItem('members'));
      if(members && members[this.userId]) {
        let user = members[this.userId];
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.image = user.image;
      } else {
        this.userService.findByIds([this.userId])
          .subscribe(res => {
            if(res && res.length > 0) {
              let user = res[0];
              this.firstName = user.firstName;
              this.lastName = user.lastName;
              this.image = user.image;
              let members = JSON.parse(localStorage.getItem('members'));
              if (!members) {
                members = {};
              }
              members[this.userId] = user;
              localStorage.setItem('members', JSON.stringify(members));
            }
          }, err => {
            console.log(err);
          });
      }
    }
  }

  ngOnDestroy(): void {}

  ngAfterViewInit(): void {
  }

}
